import { render } from "./ViewReservation.vue?vue&type=template&id=dd0c9c3c"
import script from "./ViewReservation.vue?vue&type=script&lang=js"
export * from "./ViewReservation.vue?vue&type=script&lang=js"

import "./ViewReservation.vue?vue&type=style&index=0&id=dd0c9c3c&lang=css"
script.render = render

export default script